import React from 'react'

import Icon from 'app/components/icons/icon/icon.component'
import InfoIconSVG from 'app/components/icons/info-icon/info-icon.svg'

type InfoIconProps = {
  width?: number | string
  height?: number | string
  className?: string
}

const InfoIcon = ({
  width = '21',
  height = '20',
  className,
}: InfoIconProps) => (
  <Icon
    src={InfoIconSVG}
    alt="Information icon"
    width={width}
    height={height}
    className={className}
  />
)

InfoIcon.defaultProps = {
  width: '21',
  height: '20',
  className: '',
}

export default InfoIcon
